var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoSessionImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 538,
    height: 350,
    viewBox: "0 0 538 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.039 309.108C-81.0412 307.522 7.84238 343.385 125.835 348.727C189.791 352.977 568.205 347.422 536.068 316.044C532.896 312.94 527.386 311.164 521.612 311.088C467.862 310.352 143.676 310.018 116.039 309.108Z",
    fill: "#EFEDED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M474.457 312.704L201.211 312.105L35.0242 311.771C21.4636 262.332 -0.353169 171.271 27.6862 100.706C66.0155 4.23344 176.496 -7.47556 306.85 3.26211C370.912 8.53609 456.373 23.584 507.315 100.812C546.904 160.821 507.497 277.031 474.457 312.704Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385.657 307.089C385.672 312.795 381.051 317.432 375.344 317.432H105.028C98.8812 317.432 93.8273 312.712 93.3113 306.694H93.2582V120.405C93.2582 113.006 99.2682 107.004 106.675 107.004H374.858C380.542 107.004 385.156 111.603 385.171 117.286L385.664 307.089H385.657Z",
    fill: "#D8DCE2"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M424.138 110.328V300.586H103.237V110.328C103.237 102.55 109.551 96.2363 117.336 96.2363H410.038C412.087 96.2363 414.038 96.6765 415.791 97.4657C420.708 99.6587 424.138 104.599 424.138 110.328Z",
    fill: "#D8DCE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M429.45 110.328V300.586H108.549V110.328C108.549 102.55 114.863 96.2363 122.648 96.2363H415.35C417.399 96.2363 419.35 96.6765 421.102 97.4657C426.02 99.6587 429.45 104.599 429.45 110.328Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M419.289 117.84V278.988C419.289 285.598 413.939 290.963 407.329 290.963H130.677C124.067 290.963 118.702 285.598 118.702 278.988V117.84C118.702 111.23 124.067 105.865 130.677 105.865H407.322C413.931 105.865 419.281 111.23 419.281 117.84H419.289Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M419.289 107.361H320.085V291.723H419.289V107.361Z",
    fill: "#F7F7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M407.314 290.956H403.323C409.932 290.956 415.297 285.606 415.297 278.989V118.053C415.297 111.443 409.932 106.078 403.323 106.078H407.314C413.924 106.078 419.289 111.443 419.289 118.053V278.989C419.289 285.598 413.924 290.956 407.314 290.956Z",
    fill: "#D8DCE2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.274 112.074H346.682V146.253H410.274V112.074Z",
    fill: "#EEEEEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M400.985 276.275H412.543V236.398H400.985V276.275Z",
    fill: "#EEEEEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M393.579 276.275H401.266V243.068H393.579V276.275Z",
    fill: "#EEEEEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.793 276.275H394.459V230.138H385.793V276.275Z",
    fill: "#EEEEEE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M377.127 276.275H385.793V239.987H377.127V276.275Z",
    fill: "#EEEEEE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M370.723 276.275H379.389V248.395H370.723V276.275Z",
    fill: "#EEEEEE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M362.057 276.275H370.723V230.138H362.057V276.275Z",
    fill: "#EEEEEE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M353.633 276.275H362.299V233.545H353.633V276.275Z",
    fill: "#EEEEEE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M346.682 276.275H355.348V233.317H346.682V276.275Z",
    fill: "#EEEEEE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M355.834 164.912H346.682V213.577H355.834V164.912Z",
    fill: "#EEEEEE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M363.142 172.547H355.561V213.57H363.142V172.547Z",
    fill: "#EEEEEE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M370.821 167.432H362.277V213.569H370.821V167.432Z",
    fill: "#EEEEEE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M379.373 177.281H370.829V213.569H379.373V177.281Z",
    fill: "#EEEEEE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M385.68 172.547H377.135V213.57H385.68V172.547Z",
    fill: "#EEEEEE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M394.232 167.432H385.687V213.569H394.232V167.432Z",
    fill: "#EEEEEE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M402.534 179.633H393.989V213.576H402.534V179.633Z",
    fill: "#EEEEEE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M409.386 170.609H400.841V213.568H409.386V170.609Z",
    fill: "#EEEEEE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M346.682 107.361H314.219V291.723H346.682V107.361Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M419.41 146.881H319.971V154.682H419.41V146.881Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M419.41 213.57H319.971V221.371H419.41V213.57Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M419.289 117.84V121.831C419.289 115.222 413.939 109.857 407.329 109.857H130.677C124.067 109.857 118.702 115.222 118.702 121.831V117.84C118.702 111.23 124.067 105.865 130.677 105.865H407.322C413.931 105.865 419.281 111.23 419.281 117.84H419.289Z",
    fill: "#D8DCE2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M118.702 121.831V117.84C118.702 111.23 124.067 105.865 130.677 105.865H407.322C413.931 105.865 419.281 111.23 419.281 117.84V174.647",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M419.289 193.057V278.981C419.289 285.591 413.939 290.956 407.329 290.956H130.677C124.067 290.956 118.702 285.591 118.702 278.981V135.059",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M134.281 139.984H168.278C176.838 139.984 183.789 146.935 183.789 155.495V268.434H118.771V155.495C118.771 146.935 125.722 139.984 134.281 139.984Z",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M207.935 182.82H266.958C270.32 182.82 272.793 185.985 271.982 189.248L261.919 229.618C261.342 231.925 259.271 233.542 256.896 233.542H197.873C194.503 233.542 192.037 230.377 192.849 227.114L202.911 186.744C203.488 184.437 205.56 182.82 207.935 182.82Z",
    fill: "#6592C3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M211.873 182.82H270.896C274.258 182.82 276.732 185.985 275.92 189.248L265.858 229.618C265.281 231.925 263.209 233.542 260.834 233.542H201.811C198.442 233.542 195.976 230.377 196.788 227.114L206.85 186.744C207.427 184.437 209.498 182.82 211.873 182.82Z",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M210.492 206.262H265.402L272.983 233.542H218.066L210.492 206.262Z",
    fill: "#81B0E3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M218.066 233.542L210.492 206.262H265.402L270.092 223.146",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M299.755 241.889H289.64L276.497 290.948H279.335L299.755 241.889Z",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M117.784 244.294H307.26V233.541H117.784",
    fill: "#F7F7F7"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M117.784 244.294H307.26V233.541H117.784",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M118.71 268.383H419.296V278.885C419.296 285.548 413.886 290.958 407.223 290.958H130.776C124.113 290.958 118.702 285.548 118.702 278.885V268.383H118.71Z",
    fill: "#2363A8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M139.525 280.386L131.754 285.341C131.185 285.705 130.442 285.295 130.442 284.62V274.717C130.442 274.042 131.185 273.639 131.754 273.996L139.525 278.951C140.049 279.285 140.049 280.052 139.525 280.386Z",
    fill: "#FFFFFD"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M212.996 279.674H406.798",
    stroke: "#FFFFFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M146.522 279.674H230.359",
    stroke: "#2363A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M230.359 272.76C234.181 272.76 237.273 275.852 237.273 279.674C237.273 283.495 234.181 286.588 230.359 286.588C226.537 286.588 223.445 283.495 223.445 279.674C223.445 275.852 226.537 272.76 230.359 272.76Z",
    fill: "#2363A8",
    stroke: "#2363A8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M234.009 279.673C234.009 281.692 232.377 283.324 230.359 283.324C228.34 283.324 226.709 281.692 226.709 279.673C226.709 277.655 228.34 276.023 230.359 276.023C232.377 276.023 234.009 277.663 234.009 279.673Z",
    fill: "#FFFFFD"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M444.126 296.457H83.0138V306.14H444.126V296.457Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M433.267 298.674V305.063C433.267 311.893 427.72 317.425 420.898 317.425H95.383C88.5534 317.425 83.0138 311.893 83.0138 305.063V298.674H214.355V300.586C214.355 303.652 216.844 306.141 219.91 306.141H296.363C299.429 306.141 301.918 303.652 301.918 300.586V298.674H433.259H433.267Z",
    fill: "#CBD0D8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M444.126 298.674V305.063C444.126 311.893 438.579 317.425 431.757 317.425H106.242C99.4124 317.425 93.8728 311.893 93.8728 305.063V298.674H225.214V300.586C225.214 303.652 227.703 306.141 230.769 306.141H307.222C310.288 306.141 312.777 303.652 312.777 300.586V298.674H444.118H444.126Z",
    fill: "#D8DCE2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M419.289 97.4637V134.647C419.289 138.783 415.935 142.129 411.799 142.129H245.475C241.339 142.129 237.985 138.783 237.985 134.647V96.2344H413.537C415.586 96.2344 417.536 96.6745 419.289 97.4637Z",
    fill: "#D8DCE2"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M421.899 42.3945H255.575C251.439 42.3945 248.086 45.7478 248.086 49.8843V122.779C248.086 126.916 251.439 130.269 255.575 130.269H421.899C426.036 130.269 429.389 126.916 429.389 122.779V49.8843C429.389 45.7478 426.036 42.3945 421.899 42.3945Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.086 84.6015V50.9467C248.086 46.2267 251.91 42.3945 256.638 42.3945H420.844C425.564 42.3945 429.397 46.2191 429.397 50.9467V121.724C429.397 126.444 425.572 130.276 420.844 130.276H256.638C251.918 130.276 248.086 126.452 248.086 121.724V111.017",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M267.208 56.1914H410.274",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M287.303 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M303.527 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M319.743 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M335.967 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M352.184 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M368.408 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M384.625 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M400.841 52.0098V119.524",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M267.208 70.9199H410.274",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M267.208 100.371H410.274",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M267.208 115.1H410.274",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M271.375 85.6505C288.236 50.7587 302.624 47.7841 317.163 72.9853C331.991 98.695 361.829 146.001 403.27 85.6505",
    stroke: "#72D8B9",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M266.624 85.6484H410.274",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M271.375 52.0098V119.896",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M404.621 93.0215L406.763 90.0465L406.756 91.0335L404.698 88.1215H406.259L407.575 90.0185L406.91 90.0255L408.205 88.1215H409.703L407.645 90.9775V89.9975L409.815 93.0215H408.219L406.882 91.0265H407.519L406.203 93.0215H404.621Z",
    fill: "#391F31"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M268.103 60.8457V58.7737L268.425 59.6067L266.234 55.9457H267.697L269.279 58.5987H268.432L270.021 55.9457H271.365L269.181 59.6067L269.489 58.7737V60.8457H268.103Z",
    fill: "#391F31"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M268.797 93.1195C268.377 93.1195 268.004 93.0192 267.677 92.8185C267.355 92.6178 267.101 92.3285 266.914 91.9505C266.728 91.5725 266.634 91.1128 266.634 90.5715C266.634 90.0302 266.728 89.5705 266.914 89.1925C267.101 88.8145 267.355 88.5252 267.677 88.3245C268.004 88.1238 268.377 88.0235 268.797 88.0235C269.213 88.0235 269.581 88.1238 269.903 88.3245C270.23 88.5252 270.487 88.8145 270.673 89.1925C270.86 89.5705 270.953 90.0302 270.953 90.5715C270.953 91.1128 270.86 91.5725 270.673 91.9505C270.487 92.3285 270.23 92.6178 269.903 92.8185C269.581 93.0192 269.213 93.1195 268.797 93.1195ZM268.797 91.9855C268.947 91.9855 269.077 91.9388 269.189 91.8455C269.306 91.7522 269.397 91.6028 269.462 91.3975C269.528 91.1875 269.56 90.9122 269.56 90.5715C269.56 90.2262 269.528 89.9508 269.462 89.7455C269.397 89.5402 269.306 89.3908 269.189 89.2975C269.077 89.2042 268.947 89.1575 268.797 89.1575C268.648 89.1575 268.515 89.2042 268.398 89.2975C268.286 89.3908 268.195 89.5402 268.125 89.7455C268.06 89.9508 268.027 90.2262 268.027 90.5715C268.027 90.9122 268.06 91.1875 268.125 91.3975C268.195 91.6028 268.286 91.7522 268.398 91.8455C268.515 91.9388 268.648 91.9855 268.797 91.9855Z",
    fill: "#391F31"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M270.031 53.8006L271.374 52.0098L272.718 53.8006",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M408.483 84.2988L410.274 85.6496L408.483 86.9927",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.37 43.6328H82.0652C78.3165 43.6328 75.2811 46.6682 75.2811 50.4169V70.4277C75.2811 74.1764 78.3165 77.2117 82.0652 77.2117H122.565L141.126 86.0219L137.643 77.2117H146.37C150.119 77.2117 153.154 74.1764 153.154 70.4277V50.4169C153.154 46.6682 150.119 43.6328 146.37 43.6328Z",
    fill: "#D8DCE2"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M153.503 36.5H89.1984C85.4497 36.5 82.4143 39.5354 82.4143 43.2841V63.2949C82.4143 67.0436 85.4497 70.0789 89.1984 70.0789H129.698L148.259 78.8891L144.776 70.0789H153.503C157.252 70.0789 160.287 67.0436 160.287 63.2949V43.2841C160.287 39.5354 157.252 36.5 153.503 36.5Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M105.954 46.2891H90.1317C89.1907 46.2891 88.4319 47.0479 88.4319 47.9889C88.4319 48.9298 89.1907 49.6887 90.1317 49.6887H105.954C106.895 49.6887 107.653 48.9298 107.653 47.9889C107.653 47.0479 106.895 46.2891 105.954 46.2891Z",
    fill: "#EEEEEE"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M150.119 46.2891H113.709C112.768 46.2891 112.009 47.0479 112.009 47.9889C112.009 48.9298 112.768 49.6887 113.709 49.6887H150.119C151.059 49.6887 151.818 48.9298 151.818 47.9889C151.818 47.0479 151.059 46.2891 150.119 46.2891Z",
    fill: "#EEEEEE"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M141.771 59.5305H150.119C151.06 59.5305 151.818 58.7716 151.818 57.8307C151.818 56.8897 151.06 56.1309 150.119 56.1309H141.771C140.83 56.1309 140.071 56.8897 140.071 57.8307C140.071 58.7716 140.83 59.5305 141.771 59.5305Z",
    fill: "#EEEEEE"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1317 59.5305H134.016C134.957 59.5305 135.716 58.7716 135.716 57.8307C135.716 56.8897 134.957 56.1309 134.016 56.1309H90.1317C89.1907 56.1309 88.4319 56.8897 88.4319 57.8307C88.4319 58.7716 89.1907 59.5305 90.1317 59.5305Z",
    fill: "#EEEEEE"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6015 198.239L38.424 161.693L71.1682 166.755L76.6015 198.239Z",
    fill: "#EBCE8B"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M306.873 219.789H363.498C367.635 219.789 370.988 216.436 370.988 212.299V166.086C370.988 161.949 367.635 158.596 363.498 158.596H306.873C302.737 158.596 299.383 161.949 299.383 166.086V212.299C299.383 216.436 302.737 219.789 306.873 219.789Z",
    fill: "#D8DCE2"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M316.207 210.768H372.832C376.969 210.768 380.322 207.414 380.322 203.278V157.064C380.322 152.928 376.969 149.574 372.832 149.574H316.207C312.071 149.574 308.717 152.928 308.717 157.064V203.278C308.717 207.414 312.071 210.768 316.207 210.768Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M380.322 195.241V202.215C380.322 206.935 376.497 210.767 371.77 210.767H317.262C312.542 210.767 308.71 206.943 308.71 202.215V158.119C308.71 153.399 312.534 149.566 317.262 149.566H371.77C376.49 149.566 380.322 153.391 380.322 158.119V168.826",
    stroke: "#391F31",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M331.733 185.157L331.991 184.443",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M332.241 183.76L341.067 159.439",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.92 0.96"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M341.196 159.098L341.454 158.385",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M320.76 190.87L320.047 190.612L320.738 190.293",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M321.428 189.967L331.733 185.156L357.428 194.482",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.02 1.01"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M357.792 194.619L358.505 194.877L357.815 195.196",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M357.124 195.523L346.819 200.334L321.125 191.008",
    stroke: "#E1E1DF",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.02 1.01"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M356.564 173.536L329.793 163.818L320.076 190.589L346.847 200.306L356.564 173.536Z",
    stroke: "#5A7F6C",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M346.819 200.333L358.49 194.907L368.211 168.135L356.54 173.561L346.819 200.333Z",
    stroke: "#EBCE8B",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M356.54 173.562L329.768 163.841L341.454 158.385L368.226 168.106L356.54 173.562Z",
    stroke: "#D88472",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M345.452 169.492L348.514 163.41L350.163 163.866L348.959 166.26L348.136 167.685L347.522 168.926L347.022 169.926L345.452 169.492ZM348.631 170.455C348.296 170.362 348.014 170.222 347.785 170.035C347.559 169.841 347.408 169.597 347.334 169.303C347.261 169.003 347.282 168.647 347.395 168.237C347.51 167.82 347.668 167.441 347.869 167.098C348.071 166.749 348.308 166.456 348.578 166.22C348.855 165.985 349.158 165.823 349.488 165.734C349.817 165.644 350.167 165.651 350.538 165.753C350.879 165.847 351.177 166.02 351.431 166.271C351.691 166.523 351.87 166.834 351.967 167.203C352.071 167.568 352.061 167.979 351.934 168.436C351.826 168.829 351.659 169.172 351.435 169.465C351.211 169.758 350.946 169.996 350.64 170.179C350.342 170.358 350.02 170.475 349.675 170.529C349.332 170.577 348.984 170.553 348.631 170.455ZM348.764 169.063C348.983 169.124 349.192 169.122 349.39 169.059C349.588 168.995 349.761 168.878 349.908 168.707C350.06 168.538 350.173 168.323 350.245 168.063C350.32 167.791 350.302 167.552 350.19 167.347C350.081 167.136 349.884 166.992 349.601 166.913C349.387 166.854 349.177 166.859 348.971 166.926C348.773 166.99 348.598 167.106 348.445 167.276C348.298 167.447 348.189 167.662 348.117 167.923C348.042 168.194 348.06 168.433 348.171 168.638C348.283 168.843 348.48 168.985 348.764 169.063Z",
    fill: "#D88472"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M337.852 185.491C337.517 185.398 337.219 185.225 336.959 184.973C336.698 184.721 336.517 184.409 336.414 184.038C336.317 183.669 336.331 183.256 336.458 182.799C336.566 182.406 336.733 182.063 336.957 181.77C337.181 181.477 337.442 181.241 337.741 181.062C338.045 180.885 338.369 180.772 338.712 180.724C339.063 180.671 339.411 180.693 339.758 180.789C340.14 180.894 340.446 181.06 340.676 181.285C340.914 181.506 341.051 181.8 341.087 182.164C341.125 182.523 341.032 182.971 340.809 183.507C340.612 184.019 340.36 184.444 340.055 184.783C339.75 185.122 339.411 185.355 339.04 185.483C338.67 185.605 338.274 185.607 337.852 185.491ZM338.791 184.322C339.011 184.382 339.22 184.381 339.418 184.318C339.616 184.254 339.789 184.137 339.936 183.966C340.088 183.796 340.201 183.581 340.272 183.321C340.348 183.049 340.329 182.811 340.218 182.606C340.108 182.395 339.912 182.25 339.628 182.172C339.414 182.113 339.205 182.117 338.999 182.185C338.801 182.248 338.626 182.365 338.473 182.534C338.326 182.705 338.217 182.921 338.145 183.181C338.07 183.453 338.088 183.692 338.199 183.897C338.311 184.102 338.508 184.243 338.791 184.322ZM339.14 185.763L339.523 185.019L340.265 183.552L340.902 182.057L341.29 181.296L342.938 181.751L340.702 186.194L339.14 185.763Z",
    fill: "#5A7F6C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M357.638 188.858C357.122 188.783 356.687 188.625 356.334 188.385C355.981 188.145 355.722 187.847 355.556 187.489C355.397 187.126 355.349 186.725 355.414 186.286C355.492 185.751 355.689 185.295 356.006 184.917C356.323 184.533 356.725 184.252 357.211 184.075C357.698 183.898 358.233 183.852 358.814 183.937C359.361 184.017 359.816 184.202 360.179 184.492C360.549 184.783 360.793 185.146 360.911 185.581L359.368 186.056C359.312 185.817 359.208 185.635 359.057 185.51C358.911 185.385 358.735 185.308 358.527 185.277C358.301 185.244 358.088 185.274 357.886 185.365C357.692 185.452 357.53 185.586 357.4 185.767C357.27 185.948 357.186 186.172 357.147 186.44C357.106 186.719 357.153 186.956 357.288 187.152C357.423 187.347 357.645 187.468 357.954 187.513C358.173 187.545 358.376 187.526 358.562 187.457C358.755 187.382 358.93 187.241 359.088 187.033L360.216 187.963C359.927 188.321 359.556 188.579 359.102 188.736C358.655 188.895 358.167 188.936 357.638 188.858Z",
    fill: "#EBCE8B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M489.057 104.44L459.447 61.2617L449.468 86.7286L489.057 104.44Z",
    fill: "#EBCE8B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M494.49 134.793L471.626 142.283C469.555 135.962 473 129.17 479.313 127.106C485.635 125.035 492.419 128.48 494.49 134.793Z",
    fill: "#D88472"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M216.502 44.778L229.41 35.6719C231.922 39.2385 231.072 44.1634 227.506 46.6751C223.939 49.1869 219.014 48.337 216.502 44.7704V44.778Z",
    fill: "#5A7F6C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2258 241.145C44.3255 241.145 46.0276 239.443 46.0276 237.343C46.0276 235.243 44.3255 233.541 42.2258 233.541C40.1261 233.541 38.424 235.243 38.424 237.343C38.424 239.443 40.1261 241.145 42.2258 241.145Z",
    fill: "#5A7F6C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M515.351 283.321C515.351 285.416 513.651 287.123 511.549 287.123C509.447 287.123 507.747 285.423 507.747 283.321C507.747 281.219 509.447 279.52 511.549 279.52C513.651 279.52 515.351 281.219 515.351 283.321Z",
    fill: "#E2B754"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5709 107.836C71.4104 104.279 69.2076 100.715 65.6508 99.876C62.0939 99.0365 58.53 101.239 57.6906 104.796C56.8511 108.353 59.0539 111.917 62.6107 112.756C66.1675 113.596 69.7314 111.393 70.5709 107.836Z",
    fill: "#72D8B9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M174.887 23.8721C174.887 25.238 173.779 26.3535 172.406 26.3535C171.032 26.3535 169.924 25.2456 169.924 23.8721C169.924 22.4985 171.032 21.3906 172.406 21.3906C173.779 21.3906 174.887 22.4985 174.887 23.8721Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M302.95 21.3675C302.95 19.9864 301.827 18.8633 300.446 18.8633C299.065 18.8633 297.942 19.9864 297.942 21.3675C297.942 22.7486 299.065 23.8717 300.446 23.8717C301.827 23.8717 302.95 22.7486 302.95 21.3675Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2405 263.712C78.2405 266.292 76.1537 268.379 73.5736 268.379C70.9936 268.379 68.9067 266.292 68.9067 263.712C68.9067 261.132 70.9936 259.045 73.5736 259.045C76.1537 259.045 78.2405 261.132 78.2405 263.712Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M452.594 121.83C454.673 121.83 456.358 120.145 456.358 118.067C456.358 115.988 454.673 114.303 452.594 114.303C450.516 114.303 448.831 115.988 448.831 118.067C448.831 120.145 450.516 121.83 452.594 121.83Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9734 143.351C60.2559 143.351 61.2955 142.312 61.2955 141.029C61.2955 139.747 60.2559 138.707 58.9734 138.707C57.691 138.707 56.6514 139.747 56.6514 141.029C56.6514 142.312 57.691 143.351 58.9734 143.351Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M501.001 163.317C502.003 163.317 502.815 162.505 502.815 161.503C502.815 160.501 502.003 159.689 501.001 159.689C500 159.689 499.188 160.501 499.188 161.503C499.188 162.505 500 163.317 501.001 163.317Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3007 201.563C55.3007 203.24 53.9347 204.605 52.2577 204.605C50.5806 204.605 49.2147 203.24 49.2147 201.563C49.2147 199.885 50.5806 198.52 52.2577 198.52C53.9347 198.52 55.3007 199.885 55.3007 201.563Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M232.415 78.6072C232.415 76.4066 230.632 74.6309 228.439 74.6309C226.246 74.6309 224.463 76.4141 224.463 78.6072C224.463 80.8003 226.246 82.5836 228.439 82.5836C230.632 82.5836 232.415 80.8003 232.415 78.6072Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0138 121.9H64.3613V126.332H83.0138V121.9Z",
    fill: "#D8DCE2"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0138 129.07H64.3613V133.502H83.0138V129.07Z",
    fill: "#D8DCE2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M200.605 26.8164H181.952V31.2481H200.605V26.8164Z",
    fill: "#D8DCE2"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M193.494 38.3595V19.707H189.063V38.3595H193.494Z",
    fill: "#D8DCE2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M453.854 130.547L440.665 143.736L443.799 146.87L456.988 133.681L453.854 130.547Z",
    fill: "#D8DCE2"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M456.992 143.74L443.803 130.551L440.669 133.684L453.859 146.874L456.992 143.74Z",
    fill: "#D8DCE2"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M336.522 13.2053L323.332 26.3945L326.466 29.5282L339.655 16.3389L336.522 13.2053Z",
    fill: "#D8DCE2"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M326.421 18.8936C327.854 18.8936 329.016 17.7317 329.016 16.2984C329.016 14.8651 327.854 13.7031 326.421 13.7031C324.988 13.7031 323.826 14.8651 323.826 16.2984C323.826 17.7317 324.988 18.8936 326.421 18.8936Z",
    fill: "#D8DCE2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M336.567 29.0323C338 29.0323 339.162 27.8704 339.162 26.4371C339.162 25.0037 338 23.8418 336.567 23.8418C335.134 23.8418 333.972 25.0037 333.972 26.4371C333.972 27.8704 335.134 29.0323 336.567 29.0323Z",
    fill: "#D8DCE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSessionImage);
export default __webpack_public_path__ + "static/media/noSessionImage.34b4525a2cf0af95bab91aac1665f95c.svg";
export { ForwardRef as ReactComponent };